// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) { return "css/" + "admin" + "." + "275c7f60" + ".css"; };